import { ref, toValue, defineComponent, computed, createBlock, openBlock, unref, createSlots, withCtx, createVNode, createTextVNode, toDisplayString, createElementVNode, renderSlot } from "vue";
import { d as mdiCheck, l as mdiContentCopy } from "./mdi-8kZvl9vo.mjs";
import { whenever } from "@vueuse/core";
import { N as NcFormBoxButton } from "./NcFormBoxButton-CCs-0mb3.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-5AA93z-F.mjs";
import { r as register, a as t } from "./_l10n--WxGDYem.mjs";
register();
/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const DELAY = 2e3;
function useCopy(content) {
  const isCopied = ref(false);
  async function copy() {
    if (isCopied.value) {
      return;
    }
    const value = toValue(content);
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      prompt("", value);
    }
    isCopied.value = true;
    setTimeout(() => {
      isCopied.value = false;
    }, DELAY);
  }
  return {
    isCopied,
    copy
  };
}
const _hoisted_1 = { class: "hidden-visually" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBoxCopyButton",
  props: {
    label: { default: () => void 0 },
    value: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["copy"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const { isCopied, copy } = useCopy(() => __props.value);
    const icon = computed(() => isCopied.value ? mdiCheck : mdiContentCopy);
    whenever(isCopied, () => emit("copy"));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(NcFormBoxButton, {
        disabled: _ctx.disabled,
        "inverted-accent": "",
        onClick: unref(copy)
      }, createSlots({
        description: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.value), 1)
        ]),
        icon: withCtx(() => [
          createVNode(NcIconSvgWrapper, {
            path: icon.value,
            inline: ""
          }, null, 8, ["path"])
        ]),
        _: 2
      }, [
        _ctx.$slots.default || _ctx.label ? {
          name: "default",
          fn: withCtx(() => [
            createElementVNode("span", _hoisted_1, toDisplayString(unref(isCopied) ? unref(t)("Copied") : unref(t)("Copy to clipboard")), 1),
            renderSlot(_ctx.$slots, "default", {}, () => [
              createTextVNode(toDisplayString(_ctx.label), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["disabled", "onClick"]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcFormBoxCopyButton.vue_vue_type_script_setup_true_lang-DfPML_k7.mjs.map
